module.exports = __webpack_public_path__ + "89334ba0ed7db17a9feaf04496afdde4.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-main-320.jpg
// module id = 360
// module chunks = 0